/** @jsx jsx */
import { jsx } from "@trueskin-web/theme"

import Icon from "../icon"

const CardHint = ({ description, icon }) => (
  <div
    sx={{
      display: "flex",
      alignItems: "flex-start",
      gap: 2,
      color: "textDark",
    }}
  >
    {icon}

    <div
      sx={{
        fontSize: 12,
      }}
    >
      {description}
    </div>
  </div>
)

export default CardHint
